import { Component } from '@angular/core';

@Component({
  selector: 'app-technical-work',
  templateUrl: './technical-work.component.html',
  styleUrls: ['./technical-work.component.sass'],
})
export class TechnicalWorkComponent {}
